import { set, computed } from '@ember/object';
import { globalAddressHasValue, yearMonthDayHasValue } from '@square/dashboard-data/models/directory/attributes';
import GlobalAddress from '@square/dashboard-data/models/squareup/common/location/global-address';
import { YearMonthDay } from '@square/dashboard-data/models/squareup/common/time';

/**

## ContactProfile Module

Collection of functions for managing rolodex.Profile messages.

*/

// This is required to setup sub-models since they may not be automatically
// created if they are not part of the original json hash during create, since
// attr with DeprecatedEmberModelBaseModel get does not return an object if it's never set.
export function inflateProfile(profile) {
  if (!profile.address) {
    set(profile, 'address', GlobalAddress.create());
  }
  if (!profile.birthday) {
    set(profile, 'birthday', YearMonthDay.create());
  }
}
export function cleanupProfile(profile) {
  const address = profile.address;
  if (address && !globalAddressHasValue(address)) {
    set(profile, 'address', null);
  }
  const birthday = profile.birthday;
  if (birthday && !yearMonthDayHasValue(birthday)) {
    set(profile, 'birthday', null);
  }
}
export function isProfileDirty(profile) {
  // eslint-disable-next-line no-param-reassign
  profile = profile || {};
  return profile.isDirty || profile.address?.isDirty || profile.birthday?.isDirty;
}
export function isProfileDirtyProperty(propertyKey = 'profile') {
  return computed(`${propertyKey}.{isDirty,address.isDirty,birthday.isDirty}`, function () {
    return isProfileDirty(this.get(propertyKey));
  });
}